import { useMemo } from 'react';
import { useSubordinatedListsData } from '../../hooks/useSubordinatedListsData';
import { Combobox, ItemsListProps } from '../atoms/Combobox';

type ListSelectorProps = {
	selectedList?: string;
	onUpdateList: (value: string) => void;
};

export const ListSelector = ({
	selectedList,
	onUpdateList
}: ListSelectorProps) => {
	const { lists = [], subordinateLists = [] } = useSubordinatedListsData();

	const listsList = useMemo(() => {
		const listOptions = [...lists, ...subordinateLists];

		if (listOptions.length === 0) return [];

		const formattedList: ItemsListProps = listOptions.map(
			({ id, name }) => ({
				id,
				label: name,
				value: id
			})
		);

		return formattedList;
	}, [lists, subordinateLists]);

	return (
		<Combobox
			itemsList={listsList}
			placeholder="Lists"
			emptyMessage="No list found."
			selectedItem={selectedList}
			onUpdateSelectedItem={onUpdateList}
		/>
	);
};
